import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import {
    Dialog,
    Box,
    Typography,
    Button,
    IconButton,
    Stack,
    Divider,
    Grid,
} from '@mui/material';
import { useDispatch, useSelector } from "react-redux";
import { LoadingButton } from '@mui/lab';
import { Formik } from 'formik';
import get from "lodash/get";
import map from "lodash/map";
import CloseIcon from '@mui/icons-material/Close';
import Alert from "../../../components/form/Alert";

import InputText from "../../../components/form/InputText";
import Autocomplete from "../../../components/form/AutoComplete";
import FormatMoney from "../../../components/form/FormatMoney";
import validatorTariff from "./validatorTariff";
import Switch from "../../../components/form/Switch";
import SaveIcon from '@mui/icons-material/Save';

import { postService } from "../../../store/masters/thunk/services/post";
import { putService } from "../../../store/masters/thunk/services/put";
import { useCanView } from "../../../config/hook/UserPermissions";

const TariffModal = ({
    __,
    open,
    close,
    selected,
    setSelected,
    reload,
    setError
}) => {
   
    const idTariff = Number(get(selected, "id"));
    const dispatch = useDispatch();
    const { id } = useParams();
    const canView = useCanView();
    const [alert, setAlert] = useState({ open: false, title: "", subtitle: "", type: "" });

    // const current = useSelector(state => state.masters.client.detail);
    const current = selected
    const put = useSelector(state => state.masters.service.put);
    const post = useSelector(state => state.masters.service.post);
    const currentClient = useSelector((state) => state.masters.client.detail);
    const user = useSelector(state => state.auth.login.dataUser);
    const services = useSelector(state => state.masters.service);

    //Datos del LocalStorage
    const userData = JSON.parse(localStorage.getItem('userData'));

    //inicializamos los valores que estaran en los combobox
    const divisions = map(userData?.divisions, ({ divisionId, divisionName }) => ({
       value: divisionId,
       label: divisionName,   
        }));

    const codInvoices = map(userData?.codInvoices, ({ codInvoices, descriptions }) => ({
        value: codInvoices,
        label: descriptions,
    }))

    const municipalities = map(userData?.municipalities, ({ municipalityId, municipalityName }) => ({
        value: municipalityId,
        label: municipalityName,
    }))

    const transportTypes = map(userData?.transportTypes, ({ idTransportType, description }) => ({
        value: idTransportType,
        label: description,
    }))

    const routesTypes = map(userData?.routesTypes, ({ idRouteType, description }) => ({
        value: idRouteType,
        label: description,
    }))

    const onCloseModal = (r) => {
        setSelected({})
        close()
        if (r === "1") {
            reload()
        }
    }

    const closeAlert = () => {
        setAlert({ open: false, title: "", subtitle: "", type: "", btn: "" })
      }

    useEffect(() => {
        if (get(post, "isSuccess", false)) { onCloseModal("1") }
        if (get(post, "isReject", false)) { setError(get(post, "error", {}), "post"); close() }
        if (get(put, "isSuccess", false)) { onCloseModal("1") }
        if (get(put, "isReject", false)) { setError(get(put, "error", {}), "put"); close() }
    }, [post, put])

    const customerId = get(currentClient, "data.customerID");

    const onSubmit = (values) => {
        
        const body = {
            codInvoices: String(get(values, "COD_FACTURA")),
            customerId: String(id), 
            municipalityId: Number(get(values, "municipioStart")),
            municipalityIdEnd: Number(get(values, "municipioEnd")),
            divisionId: Number(get(values, "division")),
            idTransportType: Number(get(values, "IdTransportType")),
            price: Number(get(values, "price")),
            isAutomatic: Boolean(get(values, "isAutomatic")),
            idRouteType: Number(get(values, "RouteType")),
        }
        
        if (idTariff) { 
            if (canView("MAESTROS/CLIENTES/TARIFARIOS", "update")) {
                const baseBody = {
                    ...body,
                    id: String(idTariff)
                };
                dispatch(putService(baseBody)) 
            } else {
                setAlert({
                    open: true,
                    title: "Permiso Denegado.",
                    subtitle: (<ul> • No tienes permiso para actualizar el tarifario.</ul>),
                    type: "error",
                    btn: __(`${module}.actions.close`),
                    func: closeAlert
                })
            }
        } else { 
            if (canView("MAESTROS/CLIENTES/TARIFARIOS", "add")) {
                dispatch(postService(body)) 
            } else {
                setAlert({
                    open: true,
                    title: "Permiso Denegado.",
                    subtitle: (<ul> • No tienes permiso para crear tarifarios.</ul>),
                    type: "error",
                    btn: __(`${module}.actions.close`),
                    func: closeAlert
                })
            }
        }
    }

    const initialValues = {

        isAutomatic: idTariff ? get(current, "isAutomatic", "") : false,
        price: idTariff ? get(current, "price", "") : "",
        division: idTariff ? get(current, "divisionId", "") : "",
        COD_FACTURA:  idTariff ? get(current, "codInvoices", "") : "",
        municipioStart:  idTariff ? get(current, "municipalityId", "") : "" ,
        municipioEnd:  idTariff ? get(current, "municipalityIdEnd", "") : "" ,
        IdTransportType:  idTariff ? get(current, "idTransportType", "") : "" ,
        RouteType:  idTariff ? get(current, "idRouteType", "") : "" ,
        customerId,
    }

    return (
        <div>
            <Dialog onClose={onCloseModal} open={open} maxWidth="lg" fullWidth>
                <Box>
                    <Typography variant="h6" sx={{ mt: 2, mb: 1, ml: 3 }}>
                        {idTariff ? __("head.edit.name") : __("head.new.name")}
                    </Typography>
                    <IconButton
                        aria-label="close"
                        onClick={onCloseModal}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </Box>
                <div>
                    {!open
                        ? (
                            <Box sx={{ minHeight: 200, width: "100%" }} />
                        ) : (
                            <Formik initialValues={initialValues}
                                validationSchema={validatorTariff(__)}
                                onSubmit={onSubmit}>
                                {formik => (
                                    <form id="client-contact-form" onSubmit={get(formik, "handleSubmit")}>
                                        <div className='relative'>
                                            <Stack className="p-4" direction="row" spacing={2} justifyContent="flex-end">
                                                <Switch formik={formik} name="isAutomatic" __={__} />
                                            </Stack>
                                            <Divider />
                                            <Box className='p-4' >
                                                <Grid container spacing={{ xs: 2, md: 3 }}>
                                                    <Grid item xs={12} sm={6} md={6}>
                                                        <Autocomplete
                                                            formik={formik}
                                                            name="COD_FACTURA"
                                                            label={__(`form.COD_FACTURA.label`)}
                                                            placeholder={__(`form.COD_FACTURA.placeholder`)}
                                                            disabled={get(current, "isLoading", false) || get(post, "isLoading", false) || get(put, "isLoading", false)}
                                                            options={codInvoices}
                                                            loading={get(services, "isLoading")}

                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} sm={6} md={6}>
                                                        <InputText
                                                            formik={formik}
                                                            name="price"
                                                            label={__(`form.price.label`)}
                                                            placeholder={__(`form.price.placeholder`)}
                                                            disabled={get(current, "isLoading", false) || get(post, "isLoading", false) || get(put, "isLoading", false)}
                                                            InputProps={{
                                                                inputComponent: FormatMoney,
                                                            }}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} sm={6} md={6}>
                                                        <Autocomplete
                                                            formik={formik}
                                                            name="municipioStart"
                                                            label={__(`form.municipioStart.label`)}
                                                            placeholder={__(`form.municipioStart.placeholder`)}
                                                            disabled={get(current, "isLoading", false) || get(post, "isLoading", false) || get(put, "isLoading", false)}
                                                            options={municipalities}
                                                            loading={get(services, "isLoading")}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} sm={6} md={6}>
                                                        <Autocomplete
                                                            formik={formik}
                                                            name="municipioEnd"
                                                            label={__(`form.municipioEnd.label`)}
                                                            placeholder={__(`form.municipioEnd.placeholder`)}
                                                            disabled={get(current, "isLoading", false) || get(post, "isLoading", false) || get(put, "isLoading", false)}
                                                            options={municipalities}
                                                            loading={get(services, "isLoading")}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} sm={6} md={6}>
                                                        <Autocomplete
                                                            name="division"
                                                            formik={formik}
                                                            label={__(`form.division.label`)}
                                                            placeholder={__(`form.division.placeholder`)}
                                                            disabled={get(current, "isLoading", false) || get(post, "isLoading", false) || get(put, "isLoading", false)}
                                                            options={divisions}
                                                            loading={get(services, "isLoading")}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} sm={6} md={6}>
                                                        <Autocomplete
                                                            formik={formik}
                                                            name="IdTransportType"
                                                            label={__(`form.IdTransportType.label`)}
                                                            placeholder={__(`form.IdTransportType.placeholder`)}
                                                            disabled={get(current, "isLoading", false) || get(post, "isLoading", false) || get(put, "isLoading", false)}
                                                            options={transportTypes}
                                                            loading={get(services, "isLoading")}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} sm={6} md={6}>
                                                        <Autocomplete
                                                            formik={formik}
                                                            name="RouteType"
                                                            label={__(`form.RouteType.label`)}
                                                            placeholder={__(`form.RouteType.placeholder`)}
                                                            disabled={get(current, "isLoading", false) || get(post, "isLoading", false) || get(put, "isLoading", false)}
                                                            options={routesTypes}
                                                            loading={get(services, "isLoading")}
                                                        />
                                                    </Grid>
                                                </Grid>
                                            </Box>
                                        </div>
                                    </form>
                                )}
                            </Formik>
                        )}
                </div>
                <Stack className='p-4' direction="row" spacing={2} justifyContent="flex-end">
                    <LoadingButton variant="contained" color="secondary" type="submit" form="client-contact-form" startIcon={<SaveIcon/>} loading={get(post, "isLoading") || get(put, "isLoading")}>{__("action.save")}</LoadingButton>
                    <Button variant='outlined' color="secondary" onClick={onCloseModal} disabled={get(post, "isLoading") || get(put, "isLoading")} >{__(`action.cancel`)}</Button>
                </Stack>
                <Alert
                    title={get(alert, "title")}
                    subtitle={get(alert, "subtitle")}
                    btn1={{ func: get(alert, "func") }}
                    btn2={{}}
                    type={get(alert, "type")}
                    openAlert={get(alert, "open")}
                    closeAlert={closeAlert}
                />
            </Dialog>
        </div>
    );
}

export default TariffModal